import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Container, Grid, IconButton, Typography } from '@mui/material';
import { getPOPerformanceDetails } from '../action';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import PoBookingTable from '../Component/PoBookingTable';
import PoSummaryCard from '../Component/PoSummaryCard';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const PoPerformanceDetails = () => {
  const [isLoading, setLoading] = useState(false);
  const [poDetailsData, setPODetaildata] = useState({});
  const { company_details, comapny_entity_id } = useSelector((state) => {
    return {
      company_details: state.reportReducer.company_details,
      comapny_entity_id: state.reportReducer.comapny_entity_id,
    };
  });
  const navigate = useNavigate();

  const handleBackClick = () => navigate(-1);

  const getPODetailsData = async () => {
    setLoading(true);

    const payload = {
      manufacturer_id: company_details.id,
      user_company_esi_id: comapny_entity_id,
    };
    const { data, error, message } = await getPOPerformanceDetails(payload);
    if (!error) {
      setPODetaildata(data);
      setLoading(false);
    } else {
      setLoading(false);
      return toast.error(message);
    }
  };

  useEffect(() => {
    if (company_details?.id && comapny_entity_id ) {
      getPODetailsData();
    }
  }, [company_details?.id, comapny_entity_id]);
  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          pb: 10,
          pt: 5,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center'}}>
          {/* <Box>
            <IconButton
              aria-label='Back'
              onClick={handleBackClick}
              sx={{ mr: 0, ml: -1 }}
            >
              <ArrowBackIcon
                sx={{
                  color: '#F59C1E',
                  fontSize: 30,
                }}
              />
            </IconButton>
          </Box> */}
          <Typography variant="h2">
            My Performance
          </Typography>
        </Box>
        <Grid
          container
          spacing={2}
          justifyContent='center'
        >
          <Grid
            item
            xs={12}
          >
            <PoSummaryCard
              orderSummary={poDetailsData?.po_quantity_by_status}
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            {' '}
            {isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '50vh',
                }}
              >
                <CircularProgress sx={{ alignSelf: 'center' }} />
              </div>
            ) : (
              <PoBookingTable
                orderData={
                  poDetailsData?.sales_quantity_detailed_report?.booking_info
                }
                yearData={
                  poDetailsData?.sales_quantity_detailed_report?.year_data
                }
              />
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default PoPerformanceDetails;
